var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonstersBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "134px",
    height: "184px",
    viewBox: "0 0 134 184",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Platforma_ALL",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ALL---2---Dashboard",
    transform: "translate(-1252.000000, -4008.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(1253.000000, 4009.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.8066692,49.8826056 C109.813007,57.656804 117,70.4809692 117,84.9874529 C117,89.2886072 116.358591,93.4301621 115.183176,97.3569103 C111.656932,109.166264 103.187121,118.836584 92.1797799,123.966852 C88.5742381,125.676273 84.673588,126.877785 80.5862367,127.492092 C78.4482066,127.840401 76.2579806,128 74.0135509,128 C50.2633496,128 31,108.738658 31,84.9874529 C31,67.3281277 41.6600371,52.1531333 56.8882314,45.5543495 C61.9642961,43.3370216 67.5753703,42.0813054 73.4524435,42.0281056 C73.6401485,42 73.8258459,42 74.0135509,42 C83.2572686,42 91.8063774,44.9129405 98.8066692,49.8826056",
    id: "Fill-1",
    fill: "#E8ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,42.4995029 C41,44.4321829 39.4337264,46 37.4995028,46 C35.5662736,46 34,44.4321829 34,42.4995029 C34,40.5678171 35.5662736,39 37.4995028,39 C39.4337264,39 41,40.5678171 41,42.4995029",
    id: "Fill-3",
    fill: "#F7A800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.942,55.0185 C97.942,57.8745 95.619,60.1985 92.763,60.1985 C89.908,60.1985 87.585,57.8745 87.585,55.0185",
    id: "Fill-7",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.942,55.0185 C97.942,57.8745 95.619,60.1985 92.763,60.1985 C89.908,60.1985 87.585,57.8745 87.585,55.0185",
    id: "Stroke-9",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,51.3670901 L108,55 L76,55 L76,51.3670901 C76,50.0729338 77.0484373,48.5538783 78.3422325,48.5538783 L78.8940416,48.360544 L78.8940416,37.8721566 C78.8940416,31.5611717 83.1508545,26.3352264 89.0887144,25.0824989 C89.0739338,24.9868181 89.1084219,24.8181438 89.1084219,24.722463 C89.1084219,23.2034076 90.4820323,22 92.0004927,22 C93.0824326,22 94.1269284,22.6105814 94.5762587,23.5170826 C94.7595381,23.8850097 94.9211393,24.2795696 94.9211393,24.722463 C94.9211393,24.8181438 94.9566128,24.9927365 94.9428176,25.0874309 C96.1548268,25.3399492 97.0722094,25.7137946 98.1344419,26.2859064 C98.2635258,26.3480496 98.3935951,26.4151248 98.5157814,26.496996 C102.450377,28.7528919 105.105958,32.9993424 105.105958,37.8721566 L105.105958,48.0360185 L105.657768,48.5765655 C106.951563,48.5765655 108,50.0729338 108,51.3670901",
    id: "Fill-11",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,51.3670901 L108,55 L76,55 L76,51.3670901 C76,50.0729338 77.0484373,48.5538783 78.3422325,48.5538783 L78.8940416,48.360544 L78.8940416,37.8721566 C78.8940416,31.5611717 83.1508545,26.3352264 89.0887144,25.0824989 C89.0739338,24.9868181 89.1084219,24.8181438 89.1084219,24.722463 C89.1084219,23.2034076 90.4820323,22 92.0004927,22 C93.0824326,22 94.1269284,22.6105814 94.5762587,23.5170826 C94.7595381,23.8850097 94.9211393,24.2795696 94.9211393,24.722463 C94.9211393,24.8181438 94.9566128,24.9927365 94.9428176,25.0874309 C96.1548268,25.3399492 97.0722094,25.7137946 98.1344419,26.2859064 C98.2635258,26.3480496 98.3935951,26.4151248 98.5157814,26.496996 C102.450377,28.7528919 105.105958,32.9993424 105.105958,37.8721566 L105.105958,48.0360185 L105.657768,48.5765655 C106.951563,48.5765655 108,50.0729338 108,51.3670901 Z",
    id: "Stroke-13",
    stroke: "#1D1D1B",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,51.818212 C127.065469,68.6780261 111.385943,81 92.8067025,81 C70.2702052,81 52,62.8675592 52,40.5 C52,18.1324408 70.2702052,0 92.8067025,0 C100.780414,0 108.218331,2.26941801 114.503386,6.19185661",
    id: "Stroke-15",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4024531,167.558448 C100.578602,169.095359 102,171.629794 102,174.498042 C102,175.347748 101.87274,176.167108 101.640735,176.943395 C100.943741,179.277151 99.2688011,181.18899 97.0926523,182.203156 C96.3809743,182.540884 95.608603,182.778763 94.8009904,182.90015 C94.3790741,182.968674 93.9454106,183 93.5019578,183 C88.8070367,183 85,179.192963 85,174.498042 C85,171.006219 87.1066452,168.007774 90.1168375,166.702868 C91.1212139,166.265288 92.2293562,166.016642 93.3913394,166.005874 C93.4285385,166 93.4647587,166 93.5019578,166 C95.3286307,166 97.019233,166.576586 98.4024531,167.558448",
    id: "Fill-54",
    fill: "#85A1F8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: 112,
    x2: 0,
    y2: 128,
    id: "Stroke-56",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonstersBell);
export default __webpack_public_path__ + "static/media/monstersBell.575fe9d345fe21a615a11981439b72ea.svg";
export { ForwardRef as ReactComponent };